import React from 'react'
import { presenceErrorClass } from 'servos/formValidations'

class PersonalDetailInput extends React.Component {
  render() {
    const {
      label,
      errorMessage,
      value,
      id,
      handleInput,
    } = this.props

    const type = id === 'dateOfBirth' ? 'numeric' : 'text'

    return (
      <div className='col-12 col-sm-4'>
        <div className='form-group mr-2'>
          <label>{label}</label>
          <input
            id={id}
            className={`form-control ${presenceErrorClass(errorMessage)}`}
            value={value}
            onChange={handleInput}
            type={type}
          />
          <div className="invalid-feedback">
            { errorMessage }
          </div>
        </div>
      </div>
    )
  }
}

export default PersonalDetailInput;
